<template>
  <div class="answer-container">
    <div class="page-content">
      <img class="bg-image" :src="currentCategory.categoryImage" alt="image description" aria-hidden="true">
      <div class="question-section">
        <div class="question-holder" :class="{[currentCategory.categoryID]: true}">
          <div class="question-wrap" :class="currentAnswer.class">
            <p v-html="currentAnswer.question"></p>
            <ol class="answer-variants">
              <li v-html="currentAnswer.questionVariant1"></li>
              <li v-html="currentAnswer.questionVariant2"></li>
              <li v-html="currentAnswer.questionVariant3"></li>
            </ol>
          </div>
        </div>
        <AppButton class="btn-next" :class="currentAnswer.isRevealed ? 'active' : ''" :style="currentAnswer.isShowed ? 'visibility: hidden;' : ''" @click.prevent="revealQuestion(currentAnswer)"><span>reveal answer</span></AppButton>
      </div>
        <div class="logo-row-bottom">
          <div class="logo-holder">
            <img src="@/assets/images/ymi.png" width="53" height="43" alt="image description">
          </div>
          <div class="logo-holder">
            <img src="@/assets/images/got-milk.png" width="191" height="55" alt="image description">
            <p class="copy">&copy; 2024 California Milk Processor Board</p>
          </div>
        </div>
      <transition name="fade">
        <div class="answer-section" v-if="currentAnswer.isRevealed">
          <div class="container">
            <p v-html="currentAnswer.answerTitle ? currentAnswer.answerTitle : currentAnswer.question"></p>
            <p class="answer-text" v-html="currentAnswer.answer"></p>
            <AppButton class="btn-next" :style="revealedQuestions >= answers.length ? 'visibility: hidden;' : ''" @click.prevent="goBack()"><span>return to gameboard</span></AppButton>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapMutations } from "vuex";
  import AppButton from './elements/Button'
  export default {
    name: "Answer",
    components: {
      AppButton
    },
    computed: {
      ...mapGetters({
        answers: 'getAnswers',
        currentCategory: 'getCurrentCategory',
        currentCategoryImage() {
          return this.$store.state.blocks.find(block => block.categoryID === this.$store.state.currentCategory).categoryImage
        },
        currentAnswer: 'getCurrentAnswer',
        revealedQuestions: 'getRevealedQuestions'
      })
    },
    methods: {
      ...mapMutations({
        goToStep: 'goToStep',
        closeAnswer: 'hideAnswer',
        play: 'play',
        stop: 'stop',
        updateRevealedQuestions: 'updateRevealedQuestions'
      }),

      goBack() {
        document.body.classList.remove('answer-active');
        this.closeAnswer();
        this.stop('question_reveal');
        this.stop('answer_reveal');

        setTimeout(() => {
          if (this.currentAnswer.isRevealed) this.currentAnswer.isShowed = true
        }, 500);
      },

      makeRevealed(curAnsw) {
        curAnsw.isRevealed = true
      },

      revealQuestion(curAnsw) {
        this.play('answer_reveal')
        this.makeRevealed(curAnsw)
        this.updateRevealedQuestions()

        if (this.revealedQuestions >= this.answers.length) {
          setTimeout(() => {
            this.stop('question_reveal')
            this.stop('answer_reveal')
            this.goToStep(4)
          }, 5000)
        }
      }
    },
    mounted() {
      window.dispatchEvent(new Event('resize'));
    }
  }
</script>
